import { captureException } from "@sentry/react"
import { useQuery } from "@tanstack/react-query"
import api from "api"
import FullPageLoading from "components/FullPageLoading"
import SignUpOnboarding from "features/SignupOnboarding"
import { useGlobalContext } from "global/Context/context"
import posthog from "posthog-js"
import { useEffect } from "react"
import { Navigate, useParams } from "react-router-dom"
import routes from "routes"
import { BROWSER_STORAGE_KEYS } from "utils/constants"
import { mapErrorsV2, sleep } from "utils/helpers"
import { useEnrollments } from "utils/hooks/useEnrollments"
import { UserPreferenceManager } from "utils/userPreferenceManager"

const GsgCPAT = () => {
  const { slug } = useParams() as { slug: string }

  const { isAuthenticated } = useGlobalContext()
  const enrollments = useEnrollments()

  const signupOnboardingCompleted =
    UserPreferenceManager.get(
      BROWSER_STORAGE_KEYS.signupOnboardingCompleted
    ) === "true"

  const gsgEnrollment = useQuery({
    queryKey: ["gsg-cpat-enrollment", slug],
    queryFn: async () => {
      const res = await api.cpat.enroll({
        urlParams: {
          slug,
        },
      })
      // Waiting for the allocation to reflect in the enrollments API
      await sleep(4000)
      return res
    },
    enabled: false,
    retry: 2,
    onSuccess: async () => {
      console.log("Enrolled in CPAT successfully")
      enrollments.refetch()
      posthog?.setPersonProperties({
        cpat: true,
      })
    },
    onError: error => {
      captureException(new Error("Failed to enroll in CPAT"))
      mapErrorsV2(error)
    },
  })

  useEffect(() => {
    if (enrollments.isSuccess && isAuthenticated) {
      gsgEnrollment.refetch()
      sessionStorage.setItem("gsg_cpat_user", "true")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  if (gsgEnrollment.isLoading) {
    return <FullPageLoading debugMessage="Waiting for CPAT Enrollment" />
  }

  if (!signupOnboardingCompleted) {
    return <SignUpOnboarding redirectURL={routes.cpat.dashboard} />
  }

  return <Navigate to={routes.cpat.dashboard} replace />
}

export default GsgCPAT
